import { useSettingsHeader } from "@circle-react-shared/uikit/HeaderV3/useSettingsHeader";
import { useCircleV4OptIn } from "react/hooks/useCircleV4OptIn";
import { useBackendProps } from "react/providers/AppContext";

export const useTopBarClassNames = (
  isTopNavBarHidden: boolean,
  isMasqueradingEnabledAndActive: boolean,
): string => {
  const { isReactFlowWorkflowsRoute, isBotBuilderEditorRoute } =
    useSettingsHeader();
  const { display_header: shouldDisplayHeader = true } = useBackendProps();
  const {
    shouldShowOptInBar,
    shouldShowPreviewEnabledBar,
    shouldShowWaitlistBar,
  } = useCircleV4OptIn();

  if (
    isReactFlowWorkflowsRoute ||
    isBotBuilderEditorRoute ||
    !shouldDisplayHeader
  ) {
    return "";
  }

  // The nav header will be hidden if the subscription is expired or a promo code is active
  let topBarHeight = isTopNavBarHidden ? 0 : 64;

  if (isMasqueradingEnabledAndActive) {
    topBarHeight += 48;
  }

  if (
    shouldShowOptInBar ||
    shouldShowPreviewEnabledBar ||
    shouldShowWaitlistBar
  ) {
    topBarHeight += 48;
  }

  return `lg:h-[calc(100vh-${topBarHeight}px)]`;
};
